import React from 'react';
import {FormattedMessage} from 'react-intl';
import InvoiceListItem from '../InvoiceListItem';
import {CurrentMonthInvoice} from '../../../../common/types';
import styles from './InvoicesList.module.scss';

export interface InvoicesListListProps {
  data: CurrentMonthInvoice[];
}

const EmptyListMessage = () => (
  <div className={styles.emptyMessage}>
    <FormattedMessage
      id={'orderInvoice-modal-invoices-message-emptyList'}
      defaultMessage={"No invoices found for the current month"}
    />
  </div>
)

const InvoicesList = ({data}: InvoicesListListProps) => {
  const render = (data: CurrentMonthInvoice[]) => {
    return data.map((invoice, index) => <InvoiceListItem {...invoice} key={index}/>);
  };

  return (
    <>
      <div className={styles.lineContainer}>
        <div>
          <FormattedMessage
            id={'orderInvoice-modal-invoices-header-ID'}
            defaultMessage={'ID'}
          />
        </div>
        <div>
          <FormattedMessage
            id={'orderInvoice-modal-invoices-header-customer'}
            defaultMessage={'Customer'}
          />
        </div>
        <div>
          <FormattedMessage
            id={'orderInvoice-modal-invoices-header-createdAt'}
            defaultMessage={'Created at'}
          />
        </div>
        <div>
          <FormattedMessage
            id={'orderInvoice-modal-invoices-header-amount'}
            defaultMessage={'Amount'}
          />
        </div>
        <div>
          <FormattedMessage
            id={'orderInvoice-modal-invoices-header-actions'}
            defaultMessage={'Actions'}
          />
        </div>
      </div>
      <div className={styles.listContainer}>
        {(data.length === 0) ? <EmptyListMessage/> : render(data)}
      </div>
    </>
  );
};

export default InvoicesList;
